import { gql } from '@apollo/client';

export const GET_AGENTS = gql`
  query Agents($tenantId: String!) {
    agents(tenantId: $tenantId) {
      id
      email
      name
      phone
      role
      limit
      status
    }
  }
`;

export const ADD_AGENT = gql`
  mutation AddAgent(
    $tenantId: String
    $email: String!
    $name: String!
    $phone: String!
    $role: String!
    $limit: Float
  ) {
    addAgent(
      tenantId: $tenantId
      email: $email
      name: $name
      phone: $phone
      role: $role
      limit: $limit
    ) {
      code
      success
      message
      agent {
        id
        email
        name
        phone
        role
        limit
        status
      }
    }
  }
`;

export const UPDATE_AGENT = gql`
  mutation UpdateAgent(
    $id: ID!
    $tenantId: String
    $email: String
    $name: String
    $phone: String
    $role: String
    $limit: Float
  ) {
    updateAgent(
      id: $id
      tenantId: $tenantId
      email: $email
      name: $name
      phone: $phone
      role: $role
      limit: $limit
    ) {
      code
      success
      message
      agent {
        id
        email
        name
        phone
        role
        limit
        status
      }
    }
  }
`;

export const GET_SATELLITE_AGENTS = gql`
  query SatelliteAgents($agentId: String) {
    satelliteAgents(agentId: $agentId) {
      id
      email
      name
      phone
      role
      limit
      superAgent {
        id
        email
        name
        phone
        role
        limit
        status
      }
      status
    }
  }
`;

export const DEACTIVATE_AGENT = gql`
  mutation DeactivateAgent($id: ID!) {
    deactivateAgent(id: $id) {
      code
      success
      message
    }
  }
`;
